import React, { useEffect, useState } from 'react';
import {
	ApAuthenticationContextConsumer,
	ApSignalrConsumer,
} from '@alixpartners/ui-utils';
import {
	ButtonWrapper,
	Label,
	ModalBody,
	RecordWraper,
	Row,
	Wrapper,
} from './PushToApVendorDB.styles';
import {
	ApButtonSecondary,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import {
	getApVendorDBPipelineStatus,
	getApVendorDBPushDetails,
	pushToApVendorDB,
} from 'utils/apiRequests';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { NotificationTypes } from 'components/Toast/constants';
import ApVendorDBPushHistory from './ApVendorDBHistory/ApVendorDBPushHistory';
import Modal from 'components/Modal';

const message =
	'Push to AP Vendor DB button will be enabled when the current execution is complete.';

const PushToApVendorDB = () => {
	const [isChecking, setIsChecking] = useState(false);
	const [isGettingPublishStatus, setIsGettingPublishStatus] = useState(false);
	const [isPipelineRunning, setIsPipelineRunning] = useState(false);
	const [isProcessingModal, setIsProcessingModal] = useState(false);
	const [pushHistory, setPushHistory] = useState([]);
	const [isTriggering, setIsTriggering] = useState(false);
	const { showToast } = useToastMessageContext();

	const getPublishStatus = async () => {
		setIsGettingPublishStatus(true);
		const response = await getApVendorDBPushDetails();
		if (response.succeeded) {
			if (Object.keys(response.data).length > 0) {
				setPushHistory(response.data);
			}
			setIsGettingPublishStatus(false);
		} else {
			setIsGettingPublishStatus(false);
		}
	};

	useEffect(
		() => {
			setIsChecking(true);
			const checkIsPreccessing = async () => {
				const response = await getApVendorDBPipelineStatus();
				if (response.succeeded) {
					if (response.data.length > 0) {
						if (response.data[0].is_Processing) {
							setIsPipelineRunning(true);
						}
					}
					setIsChecking(false);
				} else {
					setIsChecking(false);
				}
			};
			// call function to check whether the pipeline is running or not
			checkIsPreccessing();

			//call to function to get last run
			getPublishStatus();
		}, // eslint-disable-next-line
		[]
	);

	const pushData = async (name, email) => {
		setIsTriggering(true);
		let bodyParam = {
			authorName: name,
			authorEmail: email,
		};
		const response = await pushToApVendorDB(bodyParam);
		if (response.succeeded) {
			if (response.data.flag === 3) {
				setIsTriggering(false);
				setIsPipelineRunning(true);
				setIsProcessingModal(true);
				showToast('Inserting data in AP Vendor DB.', NotificationTypes.success);
			}
		} else {
			setIsTriggering(false);
			showToast('Error: Pipeline failed to run', NotificationTypes.danger);
		}
	};

	const renderStatusBlock = () => {
		return (
			<Modal
				width="550px"
				zIndex="10000000"
				title="Push To AP Vendor DB Status"
				submitLabel="Ok"
				onSubmit={() => setIsProcessingModal(false)}
			>
				<ModalBody>
					<p>Pushing data into AP Vendor DB is in progress.</p>
					<p>{message}</p>
				</ModalBody>
			</Modal>
		);
	};

	return (
		<>
			<ApAuthenticationContextConsumer>
				{({ user }) => {
					const { profile } = user;
					const { name, unique_name } = profile;
					return (
						<Wrapper>
							<ButtonWrapper>
								{isChecking ? (
									<ApLoaderDefault loaderText={() => <ApLoaderText />} />
								) : (
									<>
										{isTriggering ? (
											<ApLoaderDefault loaderText={() => <ApLoaderText />} />
										) : (
											<ApButtonSecondary
												onClick={() => pushData(name, unique_name)}
												title={isPipelineRunning ? message : ''}
												disabled={isPipelineRunning}
												// disabled={true}
											>
												Push to AP Vendor DB
											</ApButtonSecondary>
										)}
									</>
								)}
							</ButtonWrapper>
							<RecordWraper>
								{isGettingPublishStatus ? (
									<ApLoaderDefault loaderText={() => <ApLoaderText />} />
								) : (
									<>
										{pushHistory.length > 0 ? (
											<>
												<p id="logs_title">Last Pushed: </p>
												<ApVendorDBPushHistory list={pushHistory} />
											</>
										) : (
											<Row>
												<ApIcon
													iconName="cloud_upload"
													iconColor={colors.grey8}
												/>
												<Label>
													No data pushed to AP Vendor DB from this environment.
												</Label>
											</Row>
										)}
									</>
								)}
							</RecordWraper>
							{isProcessingModal && renderStatusBlock()}
							<ApSignalrConsumer
								message="ApvendordbPipelineFinished"
								onMessage={(messageName, statusMessage) => {
									setIsPipelineRunning(false);
									getPublishStatus();
									parseInt(statusMessage) === 1
										? showToast(
												'Data has been successfully inserted into AP Vendor DB.',
												NotificationTypes.success
										  )
										: showToast(
												'Failed to load the data into AP Vendor DB.',
												NotificationTypes.warning
										  );
								}}
							/>
						</Wrapper>
					);
				}}
			</ApAuthenticationContextConsumer>
		</>
	);
};

export default PushToApVendorDB;
